<form [formGroup]="datosPadresForm">
  <label class="mat-small last-review-date">Última revisión: {{datosPadresForm.get('fechaActualiza')?.value}}</label>
  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombres y apellidos</mat-label>
        <input matInput formControlName="nombresApellidos" readonly>
      </mat-form-field>
    </div>
  </div>

  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Identificación</mat-label>
        <input matInput formControlName="identificacion" readonly>
      </mat-form-field>
    </div>
  </div>
  
  <div class="data-form-cont">
    <!-- <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombres</mat-label>
        <input matInput formControlName="nombres">
        <mat-error *ngIf="datosPadresForm.get('nombres').invalid">{{getErrorMessage('nombres')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Primer Apellido</mat-label>
        <input matInput formControlName="apellidoP" required>
        <mat-error *ngIf="datosPadresForm.get('apellidoP').invalid">{{getErrorMessage('apellidos')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Segundo Apellido</mat-label>
        <input matInput formControlName="apellidoS" required>
        <mat-error *ngIf="datosPadresForm.get('apellidoS').invalid">{{getErrorMessage('apellidos')}}</mat-error>
      </mat-form-field>
    </div> -->
    <!-- <mat-label>Identificación</mat-label>
    <mat-label>{{datosPadresForm.get('identificacion').value}}</mat-label> -->

    <!-- <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tipo de documento</mat-label>
        <mat-select formControlName="tipoDocumento" required>
          <mat-option *ngFor="let tipo of documentos$ | async as documentos" [value]="tipo['key']">
            {{tipo['value']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Número de documento</mat-label>
        <input matInput formControlName="documento" required>
        <mat-error *ngIf="datosPadresForm.get('documento').invalid">{{getErrorMessage('documento')}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Lugar de expedición</mat-label>
        <mat-select formControlName="lugarDocID" required>
          <mat-option *ngFor="let ciudad of ciudades$ | async as ciudades" [value]="ciudad['id']">
            {{ciudad['nombre']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Empresa donde trabaja</mat-label>
        <input matInput formControlName="empresaNombre">
        <mat-error *ngIf="datosPadresForm.get('empresaNombre').invalid">{{getErrorMessage('empresaNombre')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cargo</mat-label>
        <input matInput formControlName="empresaCargo">
        <mat-error *ngIf="datosPadresForm.get('empresaCargo').invalid">{{getErrorMessage('empresaCargo')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Profesión</mat-label>
        <input matInput formControlName="empresaProfesion">
        <mat-error *ngIf="datosPadresForm.get('empresaProfesion').invalid">{{getErrorMessage('empresaProfesion')}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Dirección trabajo</mat-label>
        <input matInput formControlName="empresaDireccion">
        <mat-error *ngIf="datosPadresForm.get('empresaDireccion').invalid">{{getErrorMessage('empresaDireccion')}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Celular</mat-label>
        <input matInput formControlName="telefonoMovil" required>
        <mat-error *ngIf="datosPadresForm.get('telefonoMovil').invalid">{{getErrorMessage('telefonoMovil')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Correo electrónico</mat-label>
        <input matInput formControlName="eMail" required>
        <mat-error *ngIf="datosPadresForm.get('eMail').invalid">{{getErrorMessage('eMail')}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
